<template>
    <div>
        <VoteSection @preload="preload"
            @loaded="loaded"
            :max="1"
            id="elecom_ep"
            category="elecom"
            type="ep" 
            title="Election Committee"
            subtitle="Enlisted Personnel"
            href="/election/vote/elecom/civilian"
            color="bg-theme-elecom"
            backable />
    </div>
</template>

<script>
import VoteSection from './../../components/sections/ElectionVoteSection.vue';

export default {
    components: {
        VoteSection,
    },
    mounted() {
        this.$emit('nofooter');
        this.$emit('checkauth');
        this.$emit('electioncheck');
    },
    methods: {
        preload() {
            this.$emit('showloader');
        },
        loaded() {
            this.$emit('hideloader');
        }
    }
}
</script>